/* Yanash v3 storefront behaviour (2026-10-27). Cart writes go through window.ynCart (yansh-cart.js, the shared side cart). */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var ILS = function (a) { return Math.round(a / 100) + ' ₪'; };
  var addItems = function (items) {
    if (window.ynCart) return window.ynCart.add(items);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; location.href = '/cart'; });
  };

  /* mobile menu */
  var menu = $('#yMenu'), burger = $('.y-burger');
  var setMenu = function (on) { if (!menu) return; menu.classList.toggle('on', on); menu.setAttribute('aria-hidden', on ? 'false' : 'true'); if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false'); document.documentElement.style.overflow = on ? 'hidden' : ''; };
  $$('[data-menu]').forEach(function (b) { b.addEventListener('click', function () { setMenu(!menu.classList.contains('on')); }); });
  $$('[data-menu-close]').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    var rv = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rv.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-rv]').forEach(function (el) { rv.observe(el); });
  } else $$('[data-rv]').forEach(function (el) { el.classList.add('in'); });

  /* flip cards */
  $$('.y-flip').forEach(function (c) { if (c.closest('[data-deck]')) return; c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); }); });

  /* edition data (homepage finder) */
  var ED = {}; try { ED = JSON.parse($('[data-eds]').textContent); } catch (e) {}

  /* FINDER: one edition per side of the family -> a set, priced at the store tiers, added in one click */
  var finder = $('[data-finder]');
  if (finder) {
    var picks = [null, null, null], out = $('[data-result]', finder);
    var draw = function () {
      var chosen = picks.filter(Boolean);
      if (!chosen.length) { out.innerHTML = '<p class="y-result-empty">בחרו לפחות צד אחד, והסט יופיע כאן.</p>'; return; }
      var live = chosen.filter(function (k) { return ED.live[k]; }), soon = chosen.filter(function (k) { return !ED.live[k]; });
      var n = live.length, uniq = soon.filter(function (k, i) { return soon.indexOf(k) === i; });
      var base = n ? ED.live[live[0]].price : 17800, full = base * n, off = n >= 3 ? 4500 : n === 2 ? 3000 : 0;
      var imgs = live.map(function (k) { return '<img src="' + ED.live[k].box + '" alt="הקופסה ב' + ED.live[k].lang + '" width="110" height="154">'; }).join('');
      var names = live.map(function (k) { return ED.live[k].lang; });
      var same = n > 1 && names.every(function (x) { return x === names[0]; });
      var h = '', p = '';
      if (n === 1) { h = 'הקופסה ב' + names[0]; p = 'מתחילים מצד אחד. רוצים להוסיף עוד אחת למתנה? שתיים ב־' + ILS(base * 2 - 3000) + '.'; }
      else if (same) { h = n + ' קופסאות ב' + names[0]; p = 'אחת לכם ואחת לסבתא. או לדודה. היא תדע.'; }
      else if (n > 1) { h = 'הסט שלכם: ' + names.join(' + '); p = 'קופסה לכל צד. ככה אף אחד בשולחן לא נשאר בלי פתגם.'; }
      if (uniq.length) p += (n ? ' ' : '') + 'הקופסה ב' + uniq.map(function (k) { return ED.soon[k]; }).join(' וב') + ' עוד לא יצאה. נשמור לכם מקום ונעדכן.';
      var html = '<div class="y-result-boxes">' + imgs + '</div><div><h3>' + (h || 'עוד רגע זה מוכן') + '</h3><p style="margin-top:6px">' + p + '</p></div>';
      if (n) {
        html += '<div class="y-result-price">' + ILS(full - off) + (off ? ' <s>' + ILS(full) + '</s> <em>חוסכים ' + ILS(off) + '</em>' : '') + '</div>'
          + '<button class="y-btn y-btn--block" type="button" data-set-add>הוספת ' + (n === 1 ? 'הקופסה' : 'הסט') + ' לסל</button>';
      }
      if (uniq.length) html += '<a class="y-btn y-btn--ghost y-btn--block" href="#wl" data-wl="' + uniq[0] + '">שמרו לי את הקופסה ב' + ED.soon[uniq[0]] + '</a>';
      out.innerHTML = html;
      var b = $('[data-set-add]', out);
      if (b) b.addEventListener('click', function () {
        var q = {}; live.forEach(function (k) { q[k] = (q[k] || 0) + 1; });
        var items = Object.keys(q).map(function (k) { return { id: ED.live[k].vid, quantity: q[k] }; });
        b.disabled = true; b.textContent = 'מוסיפים...';
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { family_sides: chosen.join('+') } }) }).catch(function () {});
        addItems(items).then(function () { b.disabled = false; b.textContent = 'נוסף לסל. עוד אחד?'; })
          .catch(function () { b.disabled = false; b.textContent = 'משהו השתבש, נסו שוב'; });
      });
    };
    $$('select[data-side]', finder).forEach(function (sel) {
      sel.addEventListener('change', function () { picks[Number(sel.getAttribute('data-side'))] = sel.value || null; draw(); });
    });
  }

  /* GUESS GAME: three real cards, pick a meaning, the card flips */
  var game = $('[data-game]');
  if (game) {
    var Q = JSON.parse($('[data-game-q]').textContent), cards = $$('[data-deck] .y-flip', game), n = 0;
    var opts = $('[data-opts]', game), fb = $('[data-fb]', game), end = $('[data-end]', game), num = $('[data-n]', game);
    var round = function () {
      cards.forEach(function (c, i) { c.hidden = i !== n; c.setAttribute('aria-pressed', 'false'); });
      num.textContent = n + 1; fb.hidden = true; end.hidden = true; opts.innerHTML = '';
      Q[n].opts.forEach(function (t, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'y-opt'; b.textContent = t;
        b.addEventListener('click', function () { answer(i); }); opts.appendChild(b);
      });
    };
    var answer = function (i) {
      var ok = Q[n].ok, bs = $$('.y-opt', opts);
      bs.forEach(function (b, j) { b.disabled = true; b.classList.add(j === ok ? 'ok' : j === i ? 'no' : 'dim'); });
      fb.textContent = i === ok ? 'בדיוק. עכשיו מותר להתנשא עד הקלף הבא.' : 'קרוב. בערך כמו הנכד שבטוח שזה קשור לכדורגל.';
      fb.hidden = false; cards[n].setAttribute('aria-pressed', 'true');
      setTimeout(function () {
        if (n < Q.length - 1) { var nx = document.createElement('button'); nx.type = 'button'; nx.className = 'y-btn'; nx.style.marginTop = '12px'; nx.textContent = 'לקלף הבא'; nx.addEventListener('click', function () { n++; round(); }); opts.appendChild(nx); }
        else { end.hidden = false; end.style.display = 'flex'; }
      }, 500);
    };
    $('[data-again]', game).addEventListener('click', function () { n = 0; end.style.display = 'none'; round(); });
    round();
  }

  /* videos: tap to play with sound, one at a time */
  $$('.y-vid').forEach(function (f) {
    var v = $('video', f), b = $('button', f);
    b.addEventListener('click', function () {
      if (v.paused) { $$('.y-vid video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.y-vid').classList.remove('playing'); } }); v.muted = false; v.play(); f.classList.add('playing'); }
      else { v.pause(); f.classList.remove('playing'); }
    });
  });

  /* WAITLIST (Klaviyo client API, same list and event as the live homepage) */
  var wl = $('[data-wl-form]');
  if (wl) {
    var sel = wl.edition, req = wl.request, err = $('[data-wl-err]', wl);
    sel.addEventListener('change', function () { req.hidden = sel.value !== 'other'; });
    $$('[data-wl]').forEach(function (a) { a.addEventListener('click', function () { var k = a.getAttribute('data-wl'); if ([].some.call(sel.options, function (o) { return o.value === k; })) { sel.value = k; req.hidden = true; } }); });
    var K = 'https://a.klaviyo.com/client/', H = { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' }, co = wl.getAttribute('data-company');
    wl.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = wl.first_name.value.trim(), email = wl.email.value.trim(), ed = sel.value, edName = sel.options[sel.selectedIndex].text, r = req.value.trim();
      if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'צריך שם פרטי ומייל תקין.'; err.hidden = false; return; }
      if (ed === 'other' && !r) { err.textContent = 'ספרו לנו איזו שפה מדברים אצלכם.'; err.hidden = false; return; }
      err.hidden = true;
      var go = $('[type=submit]', wl); go.disabled = true; go.textContent = 'שומרים לכם מקום...';
      var props = { edition_interest: ed, edition_interest_name: edName }; props['waitlist_' + ed] = true; if (r) props.edition_request = r;
      var post = function (path, body) { return fetch(K + path + '?company_id=' + co, { method: 'POST', headers: H, body: JSON.stringify(body) }); };
      Promise.all([
        post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Storefront v3 edition waitlist', profile: { data: { type: 'profile', attributes: { email: email, first_name: name, properties: props } } } }, relationships: { list: { data: { type: 'list', id: wl.getAttribute('data-list') } } } } }),
        post('events', { data: { type: 'event', attributes: { properties: { edition: ed, edition_name: edName, request: r || null, source: 'storefront-v3' }, metric: { data: { type: 'metric', attributes: { name: 'Joined Edition Waitlist' } } }, profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } } } } })
      ]).then(function (rs) {
        if (!rs[0].ok) throw new Error('sub');
        $('[data-wl-fields]', wl).hidden = true; var ok = $('[data-wl-ok]', wl); ok.hidden = false;
        ok.textContent = ed === 'other' ? 'תודה, ' + name + '. רשמנו את הבקשה, ונעדכן אם השפה הזאת יוצאת לדרך.' : 'תודה, ' + name + '. כש' + edName + ' יוצאת, אתם הראשונים לדעת.';
      }).catch(function () { err.textContent = 'משהו השתבש. נסו שוב, או כתבו לנו ל־niflaot@yanash.com.'; err.hidden = false; })
        .then(function () { go.disabled = false; go.textContent = 'תודיעו לי ראשונים'; });
    });
  }

  /* COLLECTION: region chips, language search, #region= and #for= from links */
  var fl = $('[data-filters]');
  if (fl) {
    var grid = $('[data-grid]'), cnt = $('[data-count]'), btns = $$('.y-f', fl), q = $('[data-search]', fl), cur = 'all';
    var apply = function () {
      var kv = cur.split(':'), t = (q && q.value || '').trim(), shown = 0;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === cur ? 'true' : 'false'); });
      $$('.y-pc', grid).forEach(function (c) {
        var on = (cur === 'all' || c.getAttribute('data-' + kv[0]) === kv[1]) && (!t || (c.getAttribute('data-name') || '').indexOf(t) > -1);
        c.hidden = !on; if (on) shown++;
      });
      $$('.y-region-h', grid).forEach(function (h) { h.hidden = !!t || (cur !== 'all' && cur !== 'region:' + h.getAttribute('data-r')) || !$$('.y-pc[data-region="' + h.getAttribute('data-r') + '"]:not([hidden])', grid).length; });
      cnt.textContent = shown ? shown + (shown === 1 ? ' קופסה' : ' קופסאות') : 'לא מצאנו את השפה הזאת. ספרו לנו בטופס למטה, ואולי היא הבאה בתור.';
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { cur = b.getAttribute('data-f'); apply(); }); });
    if (q) q.addEventListener('input', apply);
    var hr = /region=(\w+)/.exec(location.hash); if (hr) cur = 'region:' + hr[1];
    apply();
    var FOR = { grandparents: 'לסבתא ולסבא: בחרו את השפה שהם גדלו עליה. הם יהיו המומחים בחדר.', shabbat: 'לארוחת שישי: קופסה אחת על השולחן מספיקה. שתיים אם יש שני צדדים.', hanukkah: 'לחנוכה: שמונה לילות, והקופסה יוצאת בכל אחד מהם.', hosts: 'למארחים: מתנה שנשארת על השולחן אחרי שהיין נגמר.' };
    var m = /for=(\w+)/.exec(location.hash), note = $('[data-for-note]');
    if (m && FOR[m[1]] && note) { note.textContent = FOR[m[1]]; note.hidden = false; }
  }

  /* PRODUCT: gallery, 1/2/3 with per-slot edition, sticky bar */
  $$('[data-gal]').forEach(function (g) {
    var main = $('[data-gal-main]', g);
    $$('.y-gal-thumbs button', g).forEach(function (t) {
      t.addEventListener('click', function () { $$('.y-gal-thumbs button', g).forEach(function (o) { o.setAttribute('aria-current', 'false'); }); t.setAttribute('aria-current', 'true'); main.src = t.getAttribute('data-src'); main.classList.toggle('is-card', t.hasAttribute('data-card')); });
    });
  });
  var buy = $('[data-buy]');
  if (buy) {
    var mix = $('[data-mix]', buy), tot = $('[data-total]', buy), btn = $('[data-buy-btn]', buy), berr = $('[data-buy-err]', buy);
    var q = function () { return Number(($('input[name=quantity]:checked', buy) || {}).value || 1); };
    var sync = function () {
      var n = q(); tot.textContent = ILS(Number(buy.getAttribute('data-p' + n)));
      mix.classList.toggle('on', n > 1); $('[data-slot="3"]', mix).hidden = n < 3;
    };
    $$('input[name=quantity]', buy).forEach(function (r) { r.addEventListener('change', sync); });
    buy.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = q(), ids = [Number(buy.getAttribute('data-vid'))];
      for (var s = 2; s <= n; s++) ids.push(Number($('[data-slot="' + s + '"] select', mix).value));
      var by = {}; ids.forEach(function (id) { by[id] = (by[id] || 0) + 1; });
      var items = Object.keys(by).map(function (id) { return { id: Number(id), quantity: by[id] }; });
      btn.setAttribute('aria-busy', 'true'); berr.hidden = true;
      addItems(items).then(function () { btn.removeAttribute('aria-busy'); }).catch(function () { btn.removeAttribute('aria-busy'); berr.hidden = false; });
    });
    sync();
    var st = $('[data-sticky]');
    if (st && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting && e.boundingClientRect.top < 0; st.classList.toggle('on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); $('[data-sticky-go]', st).tabIndex = on ? 0 : -1; }); }).observe(buy);
      $('[data-sticky-go]', st).addEventListener('click', function (e) { e.preventDefault(); buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }
})();
